import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import {
    chain,
    SetPaymentMethod,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

export type HandlerType = Parameters<typeof SetPaymentMethod>[0];

interface TransactionData {
    event: string;
    ecommerce: {
        currency: string;
        value: number;
        customer: string | undefined;
        payment_type: string;
        items: { item_name: string; item_id: string; price?: number; quantity: number }[];
    };
}

addToChainAfter(chain, SetPaymentMethod, SendPaymentMethodSetTracking);

function SendPaymentMethodSetTracking(props: HandlerType) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const { cartToUpdate } = props;
    if (props.parameter.isAdyenDropIn) {
        return;
    }

    if (!cartToUpdate.paymentOptions?.paymentMethods?.length) {
        return;
    }

    const state = props.getState();
    const billToState = getBillToState(state, cartToUpdate.billToId);

    const data: TransactionData = {
        event: "add_payment_info",
        ecommerce: {
            currency: getCurrency(cartToUpdate.currencySymbol),
            value: cartToUpdate.orderSubTotal,
            payment_type: props.parameter.paymentMethod,
            customer: billToState.value?.customerNumber,
            items: [],
        },
    };

    cartToUpdate.cartLines?.forEach(cartLine => {
        data.ecommerce.items.push({
            item_id: cartLine.erpNumber,
            item_name: cartLine.shortDescription,
            price: cartLine.pricing?.unitNetPrice,
            quantity: cartLine.qtyOrdered ?? 0,
        });
    });

    dataLayer.push(data);
}

function getDataLayer() {
    return (window as any).dataLayer;
}

function getCurrency(priceString: string | undefined) {
    if (priceString?.includes("$")) {
        return "USD";
    }
    return "EUR";
}
